import { MapPin, CheckCircle2 } from "lucide-react";
import { coverageAreas } from "../data/mock";

export const Coverage = () => {
  return (
    <section id="coverage" className="py-20 bg-slate-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <span className="text-slate-600 font-semibold uppercase tracking-wider text-sm">
            Service Coverage
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mt-3 mb-4">
            Hackney & East London - 20 Mile Coverage
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Fast car recovery and transport service across all Hackney postcodes and East London within 20-mile radius
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center max-w-6xl mx-auto">
          {/* Coverage map image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://images.unsplash.com/photo-1526778548025-fa2f459cd5c1?w=800&q=80"
                alt="UK coverage map"
                className="w-full h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-slate-900/40"></div>
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="text-center text-white">
                  <MapPin className="w-16 h-16 mx-auto mb-4" />
                  <h3 className="text-3xl font-bold">UK-Wide Service</h3>
                  <p className="text-lg mt-2">From Scotland to Cornwall</p>
                </div>
              </div>
            </div>
          </div>

          {/* Coverage areas list */}
          <div>
            <h3 className="text-2xl font-bold text-slate-900 mb-6">
              East London Coverage Areas
            </h3>
            <div className="grid grid-cols-1 gap-3">
              {coverageAreas.map((area, index) => (
                <div 
                  key={index}
                  className="flex items-center gap-3 p-4 bg-white rounded-lg border border-slate-100 hover:border-slate-300 transition-colors"
                >
                  <CheckCircle2 className="w-6 h-6 text-green-600 flex-shrink-0" />
                  <span className="text-slate-700 font-medium">{area}</span>
                </div>
              ))}
            </div>
            <div className="mt-8 p-6 bg-slate-900 rounded-xl text-white">
              <p className="text-lg font-semibold mb-2">Based in Hackney, East London</p>
              <p className="text-slate-300">
                30-minute response times across Hackney and all E postcodes. We cover Shoreditch, Stratford, Bethnal Green, Islington, and all areas within 20 miles of Hackney. Fast, reliable, local service.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
